import { render } from "./ModalDatosPropietario.vue?vue&type=template&id=de024c70&scoped=true"
import script from "./ModalDatosPropietario.vue?vue&type=script&lang=js"
export * from "./ModalDatosPropietario.vue?vue&type=script&lang=js"

import "./ModalDatosPropietario.vue?vue&type=style&index=0&id=de024c70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de024c70"]])

export default __exports__